import i18next from 'i18next';
import { z } from 'zod';

/**
 * 歳出科目（款/項/目）のレベル
 */
export const EXPENDITURE_ITEM_LEVELS = ['kan', 'ko', 'moku'] as const;
export type ExpenditureItemLevel = (typeof EXPENDITURE_ITEM_LEVELS)[number];

const baseSchema = z.object({
  level: z.enum(EXPENDITURE_ITEM_LEVELS),
  accountingTypeId: z.string().optional(),
  kanId: z.string().optional(),
  koId: z.string().optional(),
  code: z.string().min(1).max(50),
  name: z.string().min(1).max(255),
});

/**
 * 歳出科目フォームのバリデーションスキーマを生成する
 *
 * 作成時: accountingTypeId 必須、level に応じて kanId/koId も必須
 * 編集時: code と name のみ検証
 */
export const createExpenditureItemsSchema = (mode: 'create' | 'edit') => {
  if (mode === 'edit') return baseSchema;

  return baseSchema.superRefine((data, ctx) => {
    const requiredMessage = i18next.t('errors.invalid_type_received_undefined', { ns: 'zod' });
    if (!data.accountingTypeId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['accountingTypeId'],
        message: requiredMessage,
      });
    }
    if (data.level === 'ko' || data.level === 'moku') {
      if (!data.kanId) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['kanId'], message: requiredMessage });
      }
    }
    if (data.level === 'moku') {
      if (!data.koId) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['koId'], message: requiredMessage });
      }
    }
  });
};

export type ExpenditureItemsFormValues = z.infer<typeof baseSchema>;
